 import {createAction} from "@reduxjs/toolkit";
// import {newsFetching,newsFetched,newsFetchingError} from "../components/newsList/news_slice";
// // import {filtersFetching,filtersFetched,filtersFetchingError,activeFilterChanged} from "../components/fiiltersList/filters_slice";
//
// export const fetchNews = (request)=>(dispatch)=>{
//     dispatch(newsFetching())
//     request("http://localhost:3001/news")
//         .then(data=>dispatch(newsFetched(data)))
//         .catch(()=>dispatch(newsFetchingError()))
// }
// export const newsFetching=createAction('NEWS_FETCHING')
// export const newsFetched = createAction('NEWS_FETCHED')
// export const newsFetchingError=createAction('NEWS_FETCHING_ERROR')
// export const deleteItem=createAction('DELETE_ITEM')
export const addNews = createAction("ADD_NEWS")
export const filtersFetching=createAction('FILTERS_FETCHING')
export const filtersFetched = createAction("FILTERS_FETCHED")
export const filtersFetchingError=createAction("FILTERS_FETCHED_ERROR")
export const activeFilterChanged=createAction("ACTIVE_FILTER_CHANGED")

